import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { Flooding } from 'features/flooding/flooding.types';
import { GeoEventEditorLayout } from 'features/geoEvents/components/GeoEventEditorLayout/GeoEventEditorLayout';
import { useAuthState } from 'state/useAuthState';
import { FloodingForm } from './FloodingForm/FloodingForm';

export const CreateEditFlooding = (
  props: RouteComponentProps<{ geoEventId?: string }>,
): JSX.Element => {
  const {
    match: {
      params: { geoEventId },
    },
  } = props;
  const { t } = useTranslation();
  const {
    permissions: { canReportFlooding },
  } = useAuthState();

  return (
    <GeoEventEditorLayout
      id={geoEventId}
      hasAccess={canReportFlooding}
      createHelmetTitle={t('createEditFlooding.title.add')}
      editHelmetTitle={t('createEditFlooding.title.edit')}
      renderSuccess={(geoEvent) => (
        <FloodingForm flooding={geoEvent as unknown as Flooding} />
      )}
    />
  );
};
